/**
 * product-sticky-granel.js — solo se carga en las fichas (layout/theme.liquid, page_type product).
 *
 * 1. --ag-sticky-h (plan «tienda top» F-B4, dueño único: zona ficha).
 *    Publica en :root la altura real de la barra fija de «Añadir» (snippets/sticky-add-granel.liquid):
 *    su offsetHeight mientras está visible (.agsticky.is-visible) y 0 cuando no lo está o no existe
 *    (escritorio, ficha sin barra). La usan el aviso de cesta (custom-granel.css, zona global) y el
 *    chat (zona marketing) para colocarse encima sin taparla:
 *      bottom: calc(var(--ag-sticky-h, 82px) + 12px + env(safe-area-inset-bottom, 0px))
 *    Sin medir en cada scroll: la clase cambia con un IntersectionObserver y aquí se escucha con
 *    un MutationObserver; el tamaño, con un ResizeObserver.
 *
 * 2. Imagen fija de la ficha nativa de Horizon (.product-information__media): la ficha de la
 *    tienda es sections/main-product-granel.liquid, así que hoy no hay nada que colocar y esta
 *    parte sale sin hacer nada. Se conserva por si se vuelve a usar la sección nativa.
 */
(function () {
  var root = document.documentElement;

  // ---------- 1. --ag-sticky-h ----------
  function publicar(bar) {
    var h = bar && bar.classList.contains('is-visible') && !bar.hidden ? bar.offsetHeight : 0;
    root.style.setProperty('--ag-sticky-h', h + 'px');
  }
  function vigilarBarra() {
    var bar = document.querySelector('[data-agsticky]');
    if (!bar) { root.style.setProperty('--ag-sticky-h', '0px'); return; }
    publicar(bar);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { publicar(bar); })
        .observe(bar, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { publicar(bar); }).observe(bar);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilarBarra);
  else vigilarBarra();

  // ---------- 2. Imagen fija de la ficha nativa (sin uso con main-product-granel) ----------
  if (window.innerWidth < 750) return;
  var media = document.querySelector('.product-information__media');
  if (!media) return;

  function calcTop() {
    if (window.innerWidth < 750) { media.style.top = ''; return; }
    var totalHeight = 0;
    document.querySelectorAll('sticky-header, .header-wrapper, .announcement-bar, .pnav, [class*="announcement"], [id*="announcement"]').forEach(function (el) {
      var s = window.getComputedStyle(el);
      if (s.position === 'sticky' || s.position === 'fixed') {
        var rect = el.getBoundingClientRect();
        if (rect.top <= 4 && rect.height > 0) totalHeight = Math.max(totalHeight, rect.bottom);
      }
    });
    media.style.top = (totalHeight + 16) + 'px';
  }
  calcTop();
  window.addEventListener('resize', calcTop, { passive: true });
  window.addEventListener('scroll', calcTop, { passive: true });
})();
